<template>
  <div>
    <TextField
      v-if="mask"
      v-mask="mask"
      v-bind="$attrs"
      :value="initial_value"
      @input="on_input"
    />
    <TextField
      v-else
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script lang="ts">
import { del_mask } from '@/utils';
import { Component, Prop, Vue } from 'vue-property-decorator';
import TextField from '../global/inputs/text-field/TextField.vue';

@Component({
  components: {
    TextField,
  },
})
export default class TextBlock extends Vue {
  @Prop({ type: String, default: '' })
  mask!: string;

  /**
   * этот пропс нужен, чтобы корретно отработало первое обновление данных, когда устанавливается маска.
   * хоть в качестве value указано initial_value, но в реальности меняется value,
   * а initial_value - как был у initial_obj в начале, таким и остается
   */
  @Prop({ type: String, default: '' })
  initial_value!: string;

  on_input(val: string) {
    if (this.mask) {
      if (del_mask(val) !== this.initial_value) {
        this.$emit('input', val);
      }
    } else {
      this.$emit('input', val);
    }
  }
}
</script>
